module.exports = __webpack_public_path__ + "static/lunch-569557ff49cd53abffa9ed67accb43f6.jpg";